enum EdgeLabel {
	TOP = 'Top',
	LEFT = 'Left',
	BOTTOM = 'Bottom',
	RIGHT = 'Right',
}

export default EdgeLabel;
